const parameterStyle = {

};

export default parameterStyle;